<template>
  <div class="text-center">
    <div class="row">
      <div class="col-xs-12">
        <table class="table table-lat-lng">
          <tr><th>Latitud</th><th>Longitud</th></tr>
          <tr><td>{{ lat }}</td><td>{{ lng }}</td></tr>
        </table>
      </div>
    </div>
    <a class="lnk-mapa" :href="getMapaLink()" target="_blank">
      <img :src="getMapaImagen()" class="img-mapa">
    </a>
  </div> 
</template>
<script>
export default {
  name: 'MapaProyecto',
  props: ['zoom', 'lat', 'lng'],
  data () {
    return {
      mapOptions: {},
      center: {},
      mapZoom: 12,
      marker: []
    }
  },
  mounted () {
    if (this.zoom) {
      this.mapZoom = this.zoom
    }

    this.center = {
      lat: this.lat,
      lng: this.lng
    }
  },
  methods: {
    getMapaImagen () {
      return 'https://maps.googleapis.com/maps/api/staticmap?center=' + this.center.lat + ',' + this.center.lng + '&key=AIzaSyCBTWJffAwhvV-8K4kkIRdjK4kjI8yzu1M&zoom=8&scale=false&size=640x400&maptype=roadmap&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff6504%7Clabel:%7C' + this.center.lat + ',' + this.center.lng
    },
    getMapaLink () {
      return 'https://www.google.com/maps/dir//' + this.center.lat + ',' + this.center.lng
    }
  }
}
</script>
<style scoped>
.img-mapa {
  max-width: 100%!important;
}

  table.table-lat-lng{
    border-color: #999;
  }
  table.table-lat-lng th{
    background: #ccc;
    padding: 5px;
    /*border: 1px solid #ecf0f5;*/
  }
  table.table-lat-lng td{
    padding: 5px;
  }
  table.table-lat-lng tr{
    height: 40px;
  }

</style>


// WEBPACK FOOTER //
// src/components/views/proyectos/Mapa.vue